import React from "react";
import { Collapse, Paper, Grid, TextInput, Button, Group, Title } from "@mantine/core";
import { IconFilter, IconX } from "@tabler/icons-react";

interface StudentFiltersProps {
  filters: { studentId: string; name: string; email: string };
  showFilters: boolean;
  onFilterChange: (field: string, value: string) => void;
  onResetFilters: () => void;
}

export const StudentFilters: React.FC<StudentFiltersProps> = ({
  filters,
  showFilters,
  onFilterChange,
  onResetFilters,
}) => {
  return (
    <Collapse in={showFilters} transitionDuration={300}>
      <Paper
        shadow="sm"
        p="md"
        radius="md"
        withBorder
        className="bg-gray-50 dark:bg-gray-800 mb-3"
      >
        <Group justify="space-between" mb="md">
          <Group gap="xs">
            <IconFilter size={20} />
            <Title order={4}>Filters</Title>
          </Group>
          <Button
            variant="subtle"
            color="gray"
            size="sm"
            onClick={onResetFilters}
            // leftIcon={<IconX size={16} />}
          >
            Clear
          </Button>
        </Group>

        <Grid gutter="md">
          <Grid.Col span={{ base: 12, sm: 6, md: 4 }}>
            <TextInput
              label="Student ID"
              placeholder="Search ID"
              value={filters.studentId}
              onChange={e => onFilterChange("studentId", e.target.value)}
              size="sm"
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, sm: 6, md: 4 }}>
            <TextInput
              label="Name"
              placeholder="Search Name"
              value={filters.name}
              onChange={e => onFilterChange("name", e.target.value)}
              size="sm"
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, sm: 6, md: 4 }}>
            <TextInput
              label="Email"
              placeholder="Search Email"
              value={filters.email}
              onChange={e => onFilterChange("email", e.target.value)}
              size="sm"
            />
          </Grid.Col>
        </Grid>
      </Paper>
    </Collapse>
  );
};
